module.exports = __webpack_public_path__ + "img/ind_energy.dde88b63.png";